import { render } from "./SurveyCompleted.vue?vue&type=template&id=21a8cacf&scoped=true"
import script from "./SurveyCompleted.vue?vue&type=script&lang=js"
export * from "./SurveyCompleted.vue?vue&type=script&lang=js"

import "./SurveyCompleted.vue?vue&type=style&index=0&id=21a8cacf&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-21a8cacf"

export default script